import { HttpContext, HttpContextToken, type HttpErrorResponse, type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { NEVER, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { ROUTER_LINKS } from '../../../interfaces/router-links.enum';
import { Auth0Service } from '../../oauth0';

export const IS_RETRY = new HttpContextToken<boolean>(() => false);

export const errorHandlingInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const auth = inject(Auth0Service);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        if (req.context.get(IS_RETRY)) {
          return auth.logout().pipe(switchMap(() => NEVER));
        }

        return auth.getTokenSilently(true).pipe(
          switchMap(token => {
            const retryReq = req.clone({
              setHeaders: { Authorization: `Bearer ${token}` },
              context: new HttpContext().set(IS_RETRY, true)
            });
            return next(retryReq);
          })
        );
      }

      if (error.status === 403) {
        router.navigate([ROUTER_LINKS.HOME]);
      }

      return throwError(() => error);
    })
  );
};
